// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TrL7","icon":"styles_icon__dlAwR"};